var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Wait for timeout.
 * @param delay The number of milliseconds to wait.
 */
const sleep = (delay) => {
    return new Promise(resolve => setTimeout(resolve, delay));
};
/**
 * Retries the given function until it succeeds given a number of retries and an interval between them.
 * @param callback Function to call.
 * @param interval Interval in milliseconds.
 * @param numRetries Number of retries.
 */
export const retry = (callback_1, ...args_1) => __awaiter(void 0, [callback_1, ...args_1], void 0, function* (callback, interval = 1000, numRetries = 5) {
    for (let attempt = 0; attempt < numRetries; attempt++) {
        try {
            if (attempt > 0) {
                yield sleep(interval);
            }
            return callback();
        }
        catch (e) {
            // throw on last attempt?
        }
    }
    return null;
});
